import './output-text-line.css';

export function OutputTextLine({ textLine }) {
    const processedLine = (textLine.match(/^\s*\d/) ? '**' + textLine : textLine).replace(/^\s*-/, '**');
    const matches = processedLine.match(/^\s*([*•]*)(.*)$/);
    const marker = matches ? matches[1] : '';
    const line = matches ? matches[2] : '';
    const className = marker.length === 0 ? '' : 'output-text-subitem-' + marker.length;
    return <div className={className}>{line}</div>;
}
